export const defaultAttachmentStyle = () => {
    return {
        root: {},
        subComponentStyles: {
            attachmentContainer: {
                root: {
                    width: "100%",
                    minWidth: 0,
                    maxWidth: "500px",
                },
            },
            attachmentAddContainer: {
                root: {
                    margin: "1rem 0",
                    textAlign: "center",
                    width: "500px",
                    minWidth: 0,
                    maxWidth: "100%",
                    boxSizing: "border-box",
                    height: "180px",
                    padding: "0.5rem",
                    backgroundColor: "#F3F2F1",
                    justifyContent: "center",
                    "@media (forced-colors: active)": {
                        // Fluent Link buttons opt out of color adjustment in both upload states.
                        "button.ms-Link": {
                            color: "LinkText",
                            backgroundColor: "Canvas",
                        },
                    },
                    "@media (max-width: 400px)": {
                        height: "auto",
                        minHeight: "180px",
                    },
                },
            },
            attachmentLabel: {
                root: { fontWeight: 400, fontSize: "13px" },
            },
            attachmentLabel2: {
                root: { fontWeight: 400, fontSize: "13px", textAlign: "left" },
            },
            attachmentListContainer: {
                root: {
                    width: "87%",
                    minWidth: 0,
                    maxWidth: "100%",
                    height: "200px",
                    overflowY: "auto",
                },
            },
            attachmentLink: {
                root: {
                    fontSize: "1rem",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    "@media (max-width: 400px)": {
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                    },
                },
            },
            attachmentFont: {
                root: {
                    fontSize: "13px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    "@media (max-width: 400px)": {
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                    },
                },
            },
            attachmentDocumentCard: {
                root: {
                    maxWidth: "inherit",
                    display: "flex",
                    flexFlow: "row nowrap",
                    justifyContent: "space-between",
                    whiteSpace: "nowrap",
                    alignItems: "center",
                    height: "30px",
                    minWidth: 0,
                    "@media (max-width: 400px)": {
                        height: "auto",
                        minHeight: "30px",
                    },
                },
            },
            attachmentDocumentCardTextStack: {
                root: {
                    display: "flex",
                    flexFlow: "row nowrap",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    minWidth: 0,
                },
            },
            attachmentIcon: { root: { marginLeft: "1rem", marginRight: "0.5rem" } },
            attachmentErrorText: { root: { color: "#d90000" } },
            browseFileLink: { root: { color: '#006cbe', backgroundColor: '#f3f2f1' } }
        },
    };
};
